var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"0px !important","height":"2px !important","overflow":"hidden","margin":"0"},attrs:{"data-idgo-widget":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }